<template>
  <div role="alert"
       class="inform-popup"
       id="information-message"
       ref="informationMsg"
       :class="getInformationMsg.className"
       v-if="getInformationMsg.isShown == true">
    <div class="inform-message-inner">
      <h2 class="inform-title">{{ getInformationMsg.title }}</h2>
      <p class="inform-content">{{ getInformationMsg.text }}</p>
      <button v-on:click.prevent="closeInformationMsg"

              class="inform-close"></button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'inform-msg',
  computed: {
    ...mapGetters([
      'getInformationMsg'
    ])
  },
  methods: {
    ...mapActions([
      'closeInformationMsg'
    ])
  },
  watch: {
    'getInformationMsg.isShown' (value) {
      if (value === true) {
        setTimeout(function () {
          let alert = document.getElementById('information-message')
          if (alert) {
            alert.setAttribute('tabindex', '-1')
            alert.focus()
          }
          let element = document.getElementsByTagName('HEADER')
          element[0].scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }, 500)
      }
    }
  }
}
</script>

<style src="@/assets/scss/components/inform-msg.scss" lang="scss" />



// WEBPACK FOOTER //
// InfomMsg.vue?238c0089